import React, { useState } from "react";

import ShipeeziNewGrid, { GeneralActions } from "Components/AppGrid/shipeezi-new-grid";
import { Fleet } from "Models/fleet";
import { Filters, Searches, Sort, Sorts } from "Models/shipeezi.table";
import { useTranslation } from "react-i18next";
import { Status } from "Util/enums";

import { getTeamTableColumns } from "../../../../../People/Members/Team/getTeamTableColumns";
import useEquipmentActions from "../../../hooks/useEquipmentActions";

interface TeamsTableProps {
  fleet: Fleet;
}

export const TeamsTable = (props: TeamsTableProps) => {
  const { fleet } = props;
  const { t: translate } = useTranslation();
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);
  const [searches, setSearches] = useState<Searches>([]);
  const [filters, setFilters] = useState<Filters>();
  const [sorting, setSorting] = useState<Sorts>();
  const { getFleetTeams, getFleetTeamsCount } = useEquipmentActions();

  const { data: teams, isFetching } = getFleetTeams({
    page,
    pageSize,
    equipmentId: fleet.id,
    searches,
    filters,
    sorting,
  });

  const { data: teamsTotalCount } = getFleetTeamsCount({
    equipmentId: fleet.id,
  });

  const handleSearch = (value: Searches) => {
    setSearches(value);
    setPage(0);
  };

  const handleFilter = (value: Filters) => {
    setFilters(value);
    setPage(0);
  };

  const handleSort = (sorts: Sort[]) => {
    const sorting: Sorts = [];

    sorts.forEach((sort) => sorting.push([sort.columnName, sort.direction]));

    setSorting(sorting);
  };

  const columns = getTeamTableColumns({ translate });

  const generalActions: GeneralActions = {
    orderBy: {
      left: ["handleSearch", "handleFilterBy"],
    },
    handleSearch: {
      onSearch: handleSearch,
    },
    handleFilterBy: {
      categories: [
        {
          name: translate("status"),
          column: "isActive",
          options: [
            { label: Status.ACTIVE, value: "1" },
            { label: Status.INACTIVE, value: "0" },
          ],
        },
      ],
      onChange: handleFilter,
    },
  };

  return (
    <ShipeeziNewGrid
      data={teams}
      totalItems={Number(teamsTotalCount)}
      columns={columns}
      showSelection={false}
      showSort={false}
      pageSize={pageSize}
      currentPage={page}
      loadingData={isFetching}
      pageSizeList={[10, 20, 40, 60]}
      onChangePageSize={setPageSize}
      onNextPage={setPage}
      onPreviousPage={setPage}
      onGoToPage={setPage}
      positionActionsColumn="right"
      keyExtractor={(data) => data?.id?.toString()}
      emptyData={translate("noInformationToBeShown")}
      onSorting={handleSort}
      generalActions={generalActions}
    />
  );
};
